<template>
  <div class="custom-control custom-checkbox"
       :class="[
       {disabled: disabled},
       {[`custom-checkbox-${type}`]: type}, inlineClass]">
    <input :id="cbId"
           class="custom-control-input"
           :class="inputClasses"
           type="checkbox"
           :disabled="disabled"
           :checked="isChecked"
           @change="handleChange"/>
    <label :for="cbId" class="custom-control-label">
      <slot>
        <span v-if="inline">&nbsp;</span>
      </slot>
    </label>
  </div>
</template>

<script>
export default {
  name: "base-checkbox",
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    checked: {
      type: [Array, Boolean],
      default: false,
      description: "Whether checkbox is checked",
    },
    disabled: {
      type: Boolean,
      description: "Whether checkbox is disabled",
    },
    inline: {
      type: Boolean,
      description: "Whether checkbox is inline",
    },
    inputClasses: {
      type: [String, Object, Array],
      description: "Checkbox input classes",
    },
    type: {
      type: String,
      description: "Checkbox type (e.g info, danger etc)",
    },
    value: {
      type: [String, Number, Boolean],
      description: "Checkbox value (for array support)",
    },
  },
  data() {
    return {
      cbId: "",
    };
  },
  computed: {
    isChecked() {
      if (Array.isArray(this.checked)) {
        return this.checked.includes(this.value);
      }
      return this.checked;
    },
    inlineClass() {
      return this.inline ? "form-check-inline" : "";
    },
  },
  methods: {
    handleChange(event) {
      const isChecked = event.target.checked;

      if (Array.isArray(this.checked)) {
        const newValue = [...this.checked];
        if (isChecked) {
          newValue.push(this.value);
        } else {
          const index = newValue.indexOf(this.value);
          if (index !== -1) {
            newValue.splice(index, 1);
          }
        }
        this.$emit("change", newValue);
      } else {
        this.$emit("change", isChecked);
      }
    },
  },
  created() {
    this.cbId = Math.random().toString(16).slice(2);
  },
};
</script>